namespace Matrix.Visualizer {
    export class GraphThemeColumns {
        static columnsKey = 'Visualizer.GraphTheme';
    }
}
